const PumpController = {
    title: "Pump Controller",

    date: "July 2, 2022",

    caption: "Bioreactor Pump Controller.",
    
    href: "/projects/pump-controller",
        
    images: [
        {alt: "Image 1", src: require('./../../../assets/projects/pump_controller/front.jpg')},
        {alt: "Image 2", src: require('./../../../assets/projects/pump_controller/isometric1.jpg')},
        {alt: "Image 3", src: require('./../../../assets/projects/pump_controller/isometric2.jpg')},
        {alt: "Image 4", src: require('./../../../assets/projects/pump_controller/isometric3.jpg')},
        {alt: "Image 5", src: require('./../../../assets/projects/pump_controller/isometric4.jpg')},
        {alt: "Image 6", src: require('./../../../assets/projects/pump_controller/overhead_closed.jpg')},
        {alt: "Image 7", src: require('./../../../assets/projects/pump_controller/overhead_open1.jpg')},
        {alt: "Image 8", src: require('./../../../assets/projects/pump_controller/overhead_open2.jpg')},
        {alt: "Image 9", src: require('./../../../assets/projects/pump_controller/overhead_open3.jpg')},
        {alt: "Image 10", src: require('./../../../assets/projects/pump_controller/right.jpg')},
    ],

    description: (
        <>
            <p>
                Coming soon.
            </p>
        </>
    ),
}

export default PumpController;